import { supabase } from '../../shared/supabase/supabaseClient';

/** True if the branch has at least one online-channel sale (any time). */
export async function branchHasOnlineSales(branchId: string): Promise<boolean> {
  const id = branchId.trim();
  if (!id) return false;
  try {
    const { count, error } = await supabase
      .schema('pos')
      .from('sales')
      .select('id', { count: 'exact', head: true })
      .eq('branch_id', id)
      .eq('channel', 'online');
    if (error) {
      console.warn('[sales] branchHasOnlineSales', error.message);
      return false;
    }
    return (count ?? 0) > 0;
  } catch (e) {
    console.warn('[sales] branchHasOnlineSales', e);
    return false;
  }
}
